/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_SavedInputs */

const en_us2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym saved`)
};

const pt_br2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academia salva`)
};

const es_419_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gimnasio guardado`)
};

const pt_pt2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio guardado`)
};

const fr_fr2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle enregistrée`)
};

const de_de2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio gespeichert`)
};

const it_it2_gyms_saved = /** @type {(inputs: Gyms_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestra salvata`)
};

/**
* | output |
* | --- |
* | "Gym saved" |
*
* @param {Gyms_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_saved = /** @type {((inputs?: Gyms_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_saved(inputs)
	if (locale === "es-419") return es_419_gyms_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_saved(inputs)
	if (locale === "de-DE") return de_de2_gyms_saved(inputs)
	if (locale === "it-IT") return it_it2_gyms_saved(inputs)
	return en_us2_gyms_saved(inputs)
});
export { gyms_saved as "gyms.saved" }